import { useDashboardStore } from 'modules/dashboard/store';
import { useAuthStore } from 'modules/auth/store';
import { defineStore } from 'pinia'

export const globalStore = defineStore('global', {
  state: () => ({
    loading: false,
    token: null as string | null,
    refreshToken: null as string | null
  }),
  actions: {
    async actLoading(status: boolean) {
      this.loading = status
    },
  },
})

export const useStore = () => ({
  dashboard: useDashboardStore(),
  auth: useAuthStore(),
  global: globalStore(),
});

export default useStore;